import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Button,
  Snackbar,
  Typography,
  Box,
} from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function ReviewVariations() {
  const [variations, setVariations] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const fetchPendingVariations = async () => {
    try {
      const res = await axios.get("/variations/pending");

      // Parse old_data and new_data so they're easier to display
      const formatted = res.data.map((v) => ({
        ...v,
        old_data: JSON.parse(v.old_data || "{}"),
        new_data: JSON.parse(v.new_data || "{}"),
      }));

      setVariations(formatted);
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Failed to load variations", severity: "error" });
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.post(`/variations/approve/${id}`);
      setSnackbar({ open: true, message: "Variation approved", severity: "success" });
      fetchPendingVariations();
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Approval failed", severity: "error" });
    }
  };

  const handleReject = async (id) => {
    try {
      await axios.post(`/variations/reject/${id}`);
      setSnackbar({ open: true, message: "Variation rejected", severity: "success" });
      fetchPendingVariations();
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: "Rejection failed", severity: "error" });
    }
  };

  useEffect(() => {
    fetchPendingVariations();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Paper sx={{ p: 3, borderRadius: 3 }}>
          {/* Proper Page Title */}
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#1976d2", mb: 3 }}
          >
            Review Variations
          </Typography>

          <TableContainer>
            <Table>
              {/* <TableHead>
                <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PF Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Old Data</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>New Data</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead> */}
              <TableBody>
                {variations.length > 0 ? (
                  variations.map((v, index) => (
                    <TableRow key={v.id} hover>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{v.pfno}</TableCell>
                      <TableCell>{v.category}</TableCell>

                      {/* Old Data */}
                      <TableCell>
                        <Box component="ul" sx={{ p: 0, m: 0, listStyle: "none" }}>
                          {Object.entries(v.old_data).map(([key, value]) => (
                            <li key={key}>
                              <Typography variant="body2">
                                <strong>{key}:</strong> {value}
                              </Typography>
                            </li>
                          ))}
                        </Box>
                      </TableCell>

                      {/* New Data */}
                      <TableCell>
                        <Box component="ul" sx={{ p: 0, m: 0, listStyle: "none" }}>
                          {Object.entries(v.new_data).map(([key, value]) => (
                            <li key={key}>
                              <Typography variant="body2" color="primary">
                                <strong>{key}:</strong> {value}
                              </Typography>
                            </li>
                          ))}
                        </Box>
                      </TableCell>

                      {/* Actions */}
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          sx={{ mr: 1 }}
                          onClick={() => handleApprove(v.id)}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => handleReject(v.id)}
                        >
                          Reject
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No pending variations.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </MDBox>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default ReviewVariations;
